import Link from 'next/link';
import React from 'react'
import Container from 'react-bootstrap/Container';
import { GetCmsPages } from '../api.services.js/others';
import Head from 'next/head';
import { useRouter } from 'next/router';
export const getServerSideProps = async () => {
  const {data} = await GetCmsPages({identifier:"about-us"})
  return {
    props: {data},
  };
};
const About = (props) => {
  let router = useRouter()

  const breadCrumbSchema = () => {
    return {
      __html: `{
        "@context": "https://schema.org/", 
        "@type": "BreadcrumbList", 
        "itemListElement": [{
          "@type": "ListItem", 
          "position": 1, 
          "name": "Home",
          "item": "https://www.orientbell.com"
        },{
        "@type": "ListItem", 
        "position": 2, 
        "name": "About Us",
        "item": "https://www.orientbell.com/about-us"
      }]
      }`
    }
  } 
  return (
    <>
    <Head>
<meta charset="utf-8"/>
<title>{props?.data?.cmsPage?.meta_title}</title>
<meta name="title" content={props?.data?.cmsPage?.meta_title}/>
<meta name="description" content={props?.data?.cmsPage?.meta_description}/>
<meta name="keywords" content={props?.data?.cmsPage?.meta_keywords}/>
<script type="application/ld+json" dangerouslySetInnerHTML={ breadCrumbSchema()}/>
</Head>
       <div className='aboutus_page'>
          <Container>

            <div className='aboutus_page_data'>
                <div>
                    <img src="../about_us_1.webp" alt='image' style={{width:"100%"}}/>
                </div>
                <div>
                    <h4><span>Experience the new-age tile buying at Orientbell Signature Showrooms</span></h4>
                </div>
            </div>
            <div dangerouslySetInnerHTML={{ __html: props?.data?.cmsPage?.content }}></div>

          </Container>
       </div>
    </>
  )
}

export default About
